// src/pages/History.jsx
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "./History.css";

export default function History() {

    useEffect(() => {
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    }, []);
    
  useEffect(() => {


  
  const els = Array.from(document.querySelectorAll(".af-observe"));
  if (!els.length) return;

  const revealAll = () => els.forEach((el) => el.classList.add("is-in"));

  if (!("IntersectionObserver" in window)) {
    revealAll();
    return;
  }

  let seen = 0;
  const io = new IntersectionObserver(
    (entries) =>
      entries.forEach((e) => {
        if (e.isIntersecting) {
          e.target.classList.add("is-in");
          io.unobserve(e.target);
          seen++;
        }
      }),
    { threshold: 0.15 }
  );
  els.forEach((el) => io.observe(el));

  // Fallback: if nothing revealed yet, force it after a tick
  const t = setTimeout(() => {
    if (seen === 0) revealAll();
  }, 400);

  return () => {
    clearTimeout(t);
    io.disconnect();
  };
}, []);

  return (
    <main className="history-shell">
      
      {/* ===== Hero ===== */}
      <section className="history-hero" aria-label="COSMETINK Academy — Our Story">
        <div className="history-hero-media">
          <img
            className="history-hero-img"
            src="https://cosacademyassets.s3.us-east-2.amazonaws.com/acad2.JPG"
            alt="COSMETINK® Studio & Academy"
            loading="eager"
            decoding="async"
          />
        </div>

        {/* soft veil + bottom aligned content */}
        <div className="history-hero-veil" aria-hidden="true" />
  <header className="history-herohead">
  <div className="brand-lock brand-lock--inline">

  </div>

  <h1 className="history-title">Our Story</h1>
  <p className="history-kicker">
    A studio built on craft, mentorship, and timeless beauty.
  </p>
</header>
      </section>
      

      {/* ===== Bio / Story ===== */}
      <section className="history-body">
        <div className="history-grid">
          <article className="history-copy af-observe">
            <p>
              <strong>Nikky Altemose</strong> is the visionary CEO behind{" "}
              <strong>COSMETINK®</strong>, the go-to permanent makeup studio in the Lehigh
              Valley, where she and her team have performed <strong>12,000+ beauty
              transformations</strong>. The studio is known for state-of-the-art technique in
              microblading, ombré brows, lip blushing, and eyeliner tattoos.
            </p>

            <p>
              “Our timeless brow shapes and our elevated eye for beauty have really set us
              apart and catapulted us to where we are now,” Nikky says. “We just want to
              create beautiful looks that transcend time and trends.”
            </p>

            <p>
              Nikky began in beauty as a professional makeup artist in 2010. After
              discovering a true love for permanent cosmetics in 2015, she founded{" "}
              <strong>COSMETINK®</strong> two years later. Her skill set comes from years of
              training with world-renowned artists and staying current with the latest,
              most advanced techniques—knowledge she passes to her team and her students.
            </p>

            <p>
              As a young woman entrepreneur, Nikky has broken the glass ceiling—becoming a
              leading employer and educator for aspiring artists and entrepreneurs.
            </p>

            <div className="pullquote">
              <q>Timeless technique. Elevated taste. Results that age beautifully.</q>
            </div>

            <p>
              Recognized as a master trainer by internationally renowned{" "}
              <strong>Beauty Angels®</strong>, Nikky founded the Lehigh Valley’s first
              permanent cosmetics academy. Through COSMETINK® Academy’s certification
              programs, she mentors artists who go on to build successful careers—many
              opening studios of their own.
            </p>

            <div className="history-cta">
              <Link to="/trainers" className="cta-link">
                Meet Our Master Trainers
              </Link>
              <Link to="/vision" className="cta-link cta-link--ghost">
                Vision & History
              </Link>
            </div>
          </article>

          <aside className="history-portrait af-observe">
            <figure className="portrait-card">
              <img
                src="https://cosacademyassets.s3.us-east-2.amazonaws.com/Nikkylvs.jpg"
                alt="Nikky Altemose — CEO & Master Trainer"
                className="portrait-img"
                loading="lazy"
                decoding="async"
              />
              <figcaption className="portrait-cap">
                Nikky Altemose — CEO & Master Trainer
              </figcaption>
            </figure>

            <div className="stats-card">
              <div className="stat">
                <span className="stat-num">12,000+</span>
                <span className="stat-label">Transformations</span>
              </div>
              <div className="stat">
                <span className="stat-num">2017</span>
                <span className="stat-label">COSMETINK® Founded</span>
              </div>
              <div className="stat">
                <span className="stat-num">AAM</span>
                <span className="stat-label">Accredited Training</span>
              </div>
            </div>
          </aside>
        </div>
      </section>

      {/* ===== Accreditation strip ===== */}
      <section className="history-accredit af-observe" aria-label="Accreditation">
        <img
          className="aam-mark"
          src="https://cosacademyassets.s3.us-east-2.amazonaws.com/IMG_4959.webp"
          alt="American Academy of Micropigmentation"
          loading="lazy"
          decoding="async"
        />
        <div className="accredit-copy">
          <div className="accredit-top">American Academy of Micropigmentation</div>
          <div className="accredit-sub">Accredited Training</div>
        </div>
      </section>
    </main>
  );
}
